import React, { useEffect, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Outlet } from "react-router-dom";
import "./layout.css";
import { useSocket } from "../../context/SocketContext";

function getInitialSidebarState() {
  const stored = localStorage.getItem("sidebar_expanded");
  return stored === null ? true : stored === "true";
}

function Layout() {
  const [isSideBarShow, setIsSidebarShow] = useState(false);
  const [isExpanded, setIsExpanded] = useState(getInitialSidebarState());
  const { initializeSocket } = useSocket();

  const expandRetractSidebar = () => {
    setIsExpanded((prev) => {
      localStorage.setItem("sidebar_expanded", !prev);
      return !prev;
    });
  };

  useEffect(() => {
    initializeSocket();
  }, [initializeSocket]);

  return (
    <div className="layout">
      <Header 
        onMenuClick={() => setIsSidebarShow(!isSideBarShow)} 
        onProfileClick={() => setIsSidebarShow(false)}
      />
      <div>
        <Sidebar
          show={isSideBarShow}
          onClose={() => setIsSidebarShow(false)}
          isExpanded={isExpanded}
          expandRetractSidebar={expandRetractSidebar}
        />
        <div
          className={
            "content-wrapper min-h-[calc(100vh-4rem)] bg-gray-50 mt-16 " +
            (isExpanded ? "lg:ml-64" : "lg:ml-20")
          }
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Layout;
